/**
 * UAT #4/#10 — CM grid-field keys can drift from the JSON keys stored on a row (K1SBX has
 * "acknowledgement Stage" while rows store "acknowledgements"). Resolve a cell value by exact key,
 * then by known alias, then by a case/space-insensitive match, so a config typo cannot blank a column.
 */
const normalize = (key: string) => key.replace(/[\s_\-().]/g, "").toLowerCase();

const ALIASES: Record<string, string> = {
  acknowledgementstage: "acknowledgements",
  acknowledgementsstage: "acknowledgements",
  acknowledgementstatus: "status",
  acknowledgementsstatus: "status",
  acknowledgementstatusdate: "ackStatusDate",
  acknowledgementsstatusdate: "ackStatusDate",
  acknowledgementtype: "acknowledgementsType",
  acknowledgementstype: "acknowledgementsType",
  packagedescriptionap137: "packageDescription",
};

export const resolveGridCellValue = (row: Record<string, any> | undefined | null, field: string): any => {
  if (!row || !field) return undefined;
  if (Object.prototype.hasOwnProperty.call(row, field)) return row[field];
  const n = normalize(field);
  const alias = ALIASES[n];
  if (alias && Object.prototype.hasOwnProperty.call(row, alias)) return row[alias];
  const key = Object.keys(row).find((k) => normalize(k) === n || (alias !== undefined && normalize(k) === normalize(alias)));
  return key === undefined ? undefined : row[key];
};
